import {connect} from '@store/@common';

import {getAssignment, getTreeById} from '@store/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';

import {AssignmentForm} from './AssignmentForm';
import UserActions from 'actions/UserActions';
import {users} from '@store/user';

const mapStateToProps = {
  getAssignment,
  getKpiById: getTreeById,
  users,
};

const mapDispatchToProps = {
  fetchGoalKpiTree: KpiGoalActions.fetchGoalKpiTree,
  allAssignments: KpiGoalActions.allAssignments,
  fetchUsers: UserActions.fetchAll,
};

export default connect(AssignmentForm, mapStateToProps, mapDispatchToProps);
